import React, { CSSProperties } from "react";

interface PMButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  style?: CSSProperties;
  ariaLabel: string;
}

/**
 * Small button, meant to have a + or - put into it
 */
export function PlusMinusButton(props: PMButtonProps) {
  return (
    <button
      className="clickable"
      style={{
        fontSize: 20,
        width: 30,
        height: 30,
        paddingTop: 5,
        ...props.style,
      }}
      onClick={props.onClick}
      aria-label={props.ariaLabel}
    >
      {props.children}
    </button>
  );
}
